import React from 'react';
import PropTypes from 'prop-types';
import { Line } from '@vds/lines';

import Tax from '../component/tax';
import Product from './product';
import TotalAmount from '../component/totalAmount';
import SecurityDeposit from '../component/securityDeposit';
import ShippingDetails from '../component/shippingDetails';
import RemainingBalance from '../component/remainingBalance';
import { getAPPID, getLTEUpgrade, isWHW, isWHWP2 } from '../../../Helpers/index';
import { getProductRefData } from '../../../../../utils/plansReference';

const DueToday = (props) => {
  const {
    dueTodayList,
    dueTodayTaxes,
    dueTodayAmount,
    plansReferenceData,
    shippingDetails,
    ltePlans,
    cartDetails,
    isCartVisible,
    whwDueTodayList,
    pageName = '',
  } = props;

  const { dueatshipment } = (plansReferenceData && plansReferenceData.miniCart) || {};
  const buyOutAmount = getLTEUpgrade() && ltePlans && ltePlans.buyOutAmount ? ltePlans.buyOutAmount : '';
  const securityDepositAmount = dueTodayAmount ? dueTodayAmount?.fwaSecurityDepositAmount : '';
  const planInfo = getProductRefData('dueTodayTax', 'dueTodayTax', plansReferenceData);
  const isWHWFlow = isWHW() || isWHWP2();

  const showCartDetails = (e) => {
    if (e && e.keyCode === 9) {
      return;
    }
    props.showCartStatus(!isCartVisible);
  };

  if (!dueTodayList) {
    return null;
  }

  const nbsEnabledPages = ['cart', 'orderreview', 'confirmation'];
  const isNbsEnabledPage = pageName && getAPPID() === 'AAL' && nbsEnabledPages.includes(pageName);

  return (
    <div>
      {dueTodayAmount && (
        <TotalAmount
          showDueToday
          totalDueTodayAmount={dueTodayAmount?.dueTodayAmount}
          dueatshipment={dueatshipment}
          taxText={!isWHWP2() && dueTodayTaxes?.[0]?.dueAmount === '0.0' ? planInfo?.[0]?.taxValue : ''}
          isCartVisible={isCartVisible}
          showIcon
          showCartDetails={showCartDetails}
        />
      )}
      {isCartVisible && (
        <>
          <Product showDueToday dueTodayList={dueTodayList} plansReferenceData={plansReferenceData} whwDueTodayList={whwDueTodayList} />
          {securityDepositAmount && <SecurityDeposit securityDepositAmt={securityDepositAmount} securityDepositLabel={props.securityDeposit} />}
          {shippingDetails && (
            <ShippingDetails
              shippingDetails={shippingDetails}
              displayText={props.displayText}
              shippingText={props.shippingText}
              pageName={props.pageName}
              estimatedDeliveryDate={props.estimatedDeliveryDate}
              cartDetails={cartDetails}
              isMinicartSection
            />
          )}
          {getLTEUpgrade() && buyOutAmount !== '' ? (
            <RemainingBalance ltePlans={ltePlans} remainingBalanceTitle={props.remainingBalanceTitle} />
          ) : null}
          {dueTodayTaxes && dueTodayTaxes.length > 0 && (
            <Tax
              showDueToday={isWHWFlow ? dueTodayTaxes?.[0]?.dueAmount >= '0.0' : dueTodayTaxes?.[0]?.dueAmount !== '0.0'}
              totalDueTodayTaxAmount={dueTodayTaxes?.[0]?.dueAmount}
              taxText={isWHWFlow ? planInfo?.[0]?.taxText : dueTodayTaxes?.[0]?.dueAmount !== '0.0' ? planInfo?.[0]?.taxText : ''}
            />
          )}
        </>
      )}

      {!isNbsEnabledPage && <Line type="secondary" surface="light" />}
    </div>
  );
};

DueToday.propTypes = {
  isCartVisible: PropTypes.bool,
  dueTodayList: PropTypes.array,
  dueTodayTaxes: PropTypes.array,
  dueTodayAmount: PropTypes.object,
  plansReferenceData: PropTypes.object,
  shippingDetails: PropTypes.string,
  securityDeposit: PropTypes.string,
  remainingBalanceTitle: PropTypes.string,
  ltePlans: PropTypes.object,
  cartDetails: PropTypes.object,
  displayText: PropTypes.string,
  shippingText: PropTypes.string,
  pageName: PropTypes.string,
  whwDueTodayList: PropTypes.array,
  estimatedDeliveryDate: PropTypes.string,
  showCartStatus: PropTypes.func,
};
export default DueToday;
